import { render, staticRenderFns } from "./RegisterChallenge.vue?vue&type=template&id=de330750"
import script from "./RegisterChallenge.vue?vue&type=script&lang=js"
export * from "./RegisterChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports